<template>
  <div>
    <Modal v-model="userForm" title="修改用户" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
        <Row>
            <Col span="24">
                <FormItem label="账号" prop="userId" :class="{requireStar:true}" >
                  <Input v-model="formValidate.userId" :maxlength="10" ></Input>
                </FormItem>
            </Col>
        </Row>
          <Row>
            <Col span="24">
                  <FormItem label="密码" prop="userPassword" :class="{requireStar:true}">
                    <Input v-model="formValidate.userPassword" type="password"  :maxlength="16"></Input>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
              <FormItem label="选择省市区" prop="regionCode">
                <RadioGroup v-model="formValidate.regionCode">
                  <span @click="selRegion(1)"><Radio label="1">省</Radio></span>
                  <span @click="selRegion(2)"><Radio label="2">市</Radio></span>
                  <span @click="selRegion(3)"><Radio label="3">区/县</Radio></span>
                </RadioGroup>
             </FormItem>
            </Col>
        </Row>
        <Row v-show="showCity">
            <Col span="24">
                  <FormItem label="用户所属市级">
                    <Select ref="selectCity" v-model="formValidate.city"  @on-change="getDist" style="width:200px" :clearable="true">
                        <Option v-for="item in cityList" :value="item.groupid" :key="item.groupid">{{ item.groupname }}</Option>
                    </Select>
                  </FormItem>
            </Col>
        </Row>
        <Row v-show="showDist">
            <Col span="24">
                  <FormItem label="用户所属区县级">
                     <Select ref="selectDist" v-model="formValidate.dist" :clearable="true" style="width:200px">
                        <Option v-for="item in distList" :value="item.groupid" :key="item.groupid">
                          {{ item.groupname }}</Option>
                    </Select>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24" v-show=" showType">
                  <FormItem label="用户类型" prop="userType">
                    <RadioGroup v-model="formValidate.userType">
                      <Radio label="4">管理员</Radio>
                      <Radio label="2">操作者</Radio>
                    </RadioGroup>
                  </FormItem>
            </Col>
        </Row>
       
        <Row>
            <Col span="24">
                  <FormItem label="用户描述" prop="userDescription">
                    <Input v-model="formValidate.userDescription" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..."></Input>
                  </FormItem>
            </Col>
        </Row>
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Bus from '@/utils/bus.js'
  export default {
    components:{
    },
    data() {
        //自定义密码验证规则
          const validateUserId = (rule, value, callback)=> {
              if (value === '') {
                  callback(new Error('请输入账号'));
              } else{
                let re = /^[a-zA-Z].{2,15}$/
                if (!re.test(value)) {
                   callback(new Error('账号必须以字母开头，3-16列'));
                }else{
                     //此处防止初始化用户列表页面后，第一次点击新增按钮打不开模态窗口的问题
                    if (this.userForm == true ) {
                        let url = `/province/sys/user/getUserByUserId`
                        this.req({
                          url: url,
                          method: 'post',
                          data:{
                            userId: value
                          }
                        }).then(response => {
                            let list = response.data.list
                            if (list.length >=1 ) {
                              if(list.length==1&& list[0].userId==this.formValidate.userId1){
                                   callback();
                              }else{
                                   callback(new Error('账号已经存在'));
                              }
                            } else {
                              callback();
                            }
                            
                        }).catch(error => {
                          this.$Message.error('服务器错误:' + error);
                        })
                      }else{
                        callback();
                      }
                }
             
              }
          };
      return {
        userForm: false,
        title: '',
        show: true,
        showCity: false,
        showDist: false,
        showType: false,
        showBar: false,
        cityList: [],
        distList: [],
        formValidate: {
          id: '',
          city: '',
          dist: '',
          userId: '',
          userId1: '',
          userPassword: '',
          userPassword2: '',
          regionCode: '',
          userState:'',
          userType:'',
          userDescription:'',
          LastLogonTime:'',
          assetsManage:'',
        },
        ruleValidate: {
          regionCode: [{
            required: true,
            message: '省市区不能为空',
            trigger: 'change'
          }],
          userType: [{
            required: true,
            message: '用户类型不能为空',
            trigger: 'blur'
          }],
            userId:  [{validator: validateUserId, trigger: 'blur' }],
        },
      }
    },

    methods: {
      openModal(row) {
        
        this.userForm = true
        this.handleReset("formValidate");
        this.initUpdate(row)
        this.initRegionCode()
      },
     changCurRc(){
                let arg = arguments[0]
                let curRc = arg.groupid
                let url = "/province/sys/dcBsgroup/listByParentCode";
                this.req({
                    url: url,
                    method: 'post',
                    data:{
                        parentCode: curRc
                    }
                }).then(resp => {
                      this.showcity=true;
                      this.showcountry=true;
                      this.formValidate.distList = [] 
                      this.formValidate.cityList =[]
                    if(curRc.length==6){   //区县页面
                            this.showcity=false;
                            this.showcountry=false;
                        }else if(curRc.length==4){
                            this.showcity=false;
                            this.distList = resp.data.list
                        }else{
                            this.cityList = resp.data.list
                            if(resp.data.list.length>0){
                                this.formValidate.city=resp.data.list[0].groupid;
                                this.getDist()
                            }
                        }
                         this.loadPage()
                }).catch(error => {
                    console.log("发生错误："+error)
                })
            }, 
               getDist(){
            //先清空原有数据
                    this.distList = []
                    let url = "/province/sys/dcBsgroup/listByParentCode";
                    this.req({
                    url: url,
                    method: 'post',
                    data:{
                        parentCode: this.formValidate.city
                    }
                    }).then(resp => {
                        this.distList = resp.data.list
                    }).catch(error => {
                        console.log("发生错误："+error)
                    })
            }, 
      //修改初始化
      initUpdate(row){
            let url = `/province/sys/user/${row.id}`;
            this.req({
              url: url,
              method: 'get',
            }).then(resp => {
                let user = resp.data.data;
               // console.log(user)
                this.formValidate.id = user.id
                this.formValidate.userId = user.userId
                this.formValidate.userId1 = user.userId
                this.formValidate.userDescription = user.userDescription
                this.formValidate.userPassword = user.userPassword
                this.formValidate.userPassword2 = user.userPassword
                let rc  = user.regionCode
                
                if (rc.length == 2) {
                  this.formValidate.regionCode = '1'
                  this.showType =true
                } else if(rc.length == 4) {//如果是市级
                  this.formValidate.regionCode = '2'
                  this.formValidate.city = rc
                  this.showCity = true
                } else if(rc.length == 6) {//如果是区县
                  this.formValidate.regionCode = '3'
                  this.formValidate.city = rc.substring(0,4)
                  this.formValidate.dist = rc.substring(0,6)
                  this.showCity = true
                  this.showDist = true
                  this.getDist()
                }
                this.formValidate.userType = user.userType
              
            }).catch(error => {
                this.reponseData = "发生错误，无法显示内容"
            })
      },
      initRegionCode(){
            Bus.$on("changeCurRc",this.changCurRc)
            let curRc = this.$store.getters.getCurAreaCode().regionCode
            let url = "/province/sys/dcBsgroup/listByParentCode";
            this.req({
              url: url,
              method: 'post',
              data:{
                parentCode: curRc
              }
            }).then(resp => {
                this.cityList = resp.data.list
            }).catch(error => {
                console.log("发生错误："+error)
            })
      },
      handleSubmit(name) {
            Bus.$on("changeCurRc",this.changCurRc)
            let curRc = this.$store.getters.getCurAreaCode().regionCode
         //设置区域编码
         let regCode = null ;
          //如果是省级用户
          if (this.formValidate.regionCode == '1') {
            regCode = curRc
          }else if (this.formValidate.regionCode == '2') {
            regCode = this.formValidate.city
          }else if (this.formValidate.regionCode == '3') {
            regCode = this.formValidate.dist
          }
          if (regCode == null || regCode == '') {
              this.$Message.error('请选择省市区域!');
              return
          }
        this.$refs[name].validate((valid) => {
          if (valid) {
            let url = "/province/sys/user/save";
            let myData = {
              id: this.formValidate.id,
              regionCode: regCode,
              userId: this.formValidate.userId,
              userType: this.formValidate.userType,
              userDescription: this.formValidate.userDescription,
             // userPassword: this.formValidate.userPassword,
            }
            if(this.formValidate.userPassword2!=this.formValidate.userPassword){
              myData['userPassword'] = this.formValidate.userPassword;
            }
         
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
              if (response.status == 200) {
                this.$Message.success('保存成功!');
                this.$parent.loadPage();
              } else {
                this.$Message.error('服务器错误:' + response.status);
              }
              this.userForm = false;
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
      },
       selRegion(){
        let id = arguments[0]
        //保存用户的区域类型
        this.formValidate.regionCode = id
        //如果可以选择区县，先清空
        if (this.$refs.selectdist) {
          this.$refs.selectdist.clearSingleSelect()
        }
        //清空城市
        this.$refs.selectCity.clearSingleSelect()
        this.formValidate.city = ''
        this.formValidate.dist = ''
        this.showCity = false
        this.showDist = false
        this.showType = false
       if(id == 2) {
          this.showCity = true
        } else if(id == 3) {
          this.showCity = true
          this.showDist = true
        }else if(id==1){
          this.showType = true
        }
       
      }
    },
    mounted() {
    },
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/sys/user/UserFormUpdateProvince.vue